
import {TokenHeader} from "./types.js"

export const tokenHeader: TokenHeader = {typ: "JWT", alg: "EdDSA"}

